import { ActionableTask } from "../models";

import { EmployeeCompletePpq } from "./EmployeeCompletePpq";
import { EmployeeReviewReferralReport } from "./EmployeeReviewReferralReport";
import { EmployeeViewReferralReport } from "./EmployeeViewReferralReport";
import { EmployeeViewPpqReport } from "./EmployeeViewPpqReport";
import { BookAppointment } from "./BookAppointment";
import { EmployeeCompleteHealthSurveillanceQuestionnaire } from "./EmployeeCompleteHealthSurveillanceQuestionnaire";
import { EmployeeViewHealthSurveillanceCertificate } from "./EmployeeViewHealthSurveillanceCertificate";
import { ViewAllImmunisationsCompletedForRoleCertificate } from "./ViewAllImmunisationsCompletedForRoleCertificate";
import { ViewImmunisationClearanceCertificate } from "./ViewImmunisationClearanceCertificate";
import { EmployeeViewPhysiotherapyReferralReport } from "./EmployeeViewPhysiotherapyReferralReport";
import { EmployeeReviewPhysiotherapyReferralReport } from "./EmployeeReviewPhysiotherapyReferralReport";
import { AssociateToViewSentMessageAndDocuments } from "./AssociateToViewSentMessageAndDocuments";
import { EmployeeCompleteSra } from "./EmployeeCompleteSra";
import { EmployeeViewSraResults } from "./ViewSraResults";
import { EmployeeCompletedSraQuestionaire } from "./EmployeeCompletedSraQuestionaire";
import { EmployeeViewMHPTreatmentReport } from "./EmployeeViewMHPTreatmentReport";
import { EmployeeReviewMHPTreatmentReport } from "./EmployeeReviewMHPTreatmentReport";
import { EmployeeReviewPpqCertificate } from "./EmployeeReviewPpqCertificate";

export const taskActions: { [key: string]: (task: ActionableTask) => JSX.Element } = {
    EmployeeCompletePpq,
    EmployeeReviewReferralReport,
    EmployeeViewReferralReport,
    EmployeeViewMHPTreatmentReport,
    EmployeeReviewMHPTreatmentReport,
    EmployeeViewPpqReport,
    BookAppointment,
    EmployeeCompleteHealthSurveillanceQuestionnaire,
    EmployeeViewHealthSurveillanceCertificate,
    ViewAllImmunisationsCompletedForRoleCertificate,
    ViewImmunisationClearanceCertificate,
    EmployeeViewPhysiotherapyReferralReport,
    EmployeeReviewPhysiotherapyReferralReport,
    AssociateToViewSentMessageAndDocuments,
    EmployeeCompleteSra,
    EmployeeViewSraResults,
    EmployeeCompletedSraQuestionaire,
    EmployeeReviewPpqCertificate,
};
